import React from 'react';
import Box from 'atomic/box';
import MultiCarousel, { MultiCarouselProductsProps } from 'modules/product-carousel/components/multi-carousel/multi-carousel';
import MultiCarouselPlaceholder from 'modules/product-carousel/components/multi-carousel-placeholder/multi-carousel-placeholder';

import './products-carousel.scss';

interface ProductsCarouselProps {
    headerTitle?: string;
    products: MultiCarouselProductsProps | null;
    isMobile: boolean;
    isSlideIndicator?: boolean;
    children?: React.ReactNode;
}

const itemsMobile = 2;
const itemsDesktop = 5;

const ProductsCarousel: React.FC<ProductsCarouselProps> = ({
    headerTitle,
    children,
    products,
    isMobile,
    isSlideIndicator
}) => (
    <Box className="product-section-box products-carousel" padding={isMobile ? 'sm' : 'lg'}>
        {headerTitle && (
            <h2 className="products-carousel__header">
                {headerTitle}
            </h2>
        )}
        <div className="products-carousel__content">
            <Box className="box--mt-0">
                {products === null
                    ? <MultiCarouselPlaceholder itemCount={isMobile ? itemsMobile : itemsDesktop} />
                    : <MultiCarousel
                        products={products}
                        itemsOnDesktop={itemsDesktop}
                        itemsOnMobile={itemsMobile}
                        isMobile={isMobile}
                        isSlideIndicator={isSlideIndicator}
                    />
                }
            </Box>
            <div className="products-carousel__content__bottom">
                {children}
            </div>
        </div>
    </Box>
);

export default ProductsCarousel;
